import Vue from "vue";
import VueI18n from "vue-i18n";
import { LOCALE, FALLBACK_LOCALE } from "@/app.config";

Vue.use(VueI18n);

function loadLocaleMessages() {
    const locales = require.context("./assets/locales/languages", true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages: { [key: string]: any } = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

function loadLocaleDateTimeFormats() {
    const locales = require.context("./assets/locales/dateFormats", true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const dateTimeFormats: { [key: string]: any } = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            dateTimeFormats[locale] = locales(key);
        }
    });
    return dateTimeFormats;
}

function getLocaleFromLocalStorage() {
    return localStorage.getItem("culture") !== "null" ? localStorage.getItem("culture") : LOCALE;
}

export default new VueI18n({
    locale: getLocaleFromLocalStorage() || "en",
    fallbackLocale: FALLBACK_LOCALE || "en",
    messages: loadLocaleMessages(),
    dateTimeFormats: loadLocaleDateTimeFormats()
});
